import _ from 'lodash'
import { AntTag } from '@agro-club/agroclub-shared'
import { Deal } from 'modules/domain/deal/types'
import { FC } from 'react'
import { IconPlanner } from '../../Board/styled'
import { useTranslation } from 'react-i18next'

interface Props {
  deal: Deal
}

export const DaysSinceStatusChangeTag: FC<Props> = ({ deal }) => {
  const { t } = useTranslation('common')
  // tag is used in DealHeader too, so we need to check if the value is not null
  if (_.isNil(deal.days_since_latest_status_change)) return null
  // ts-ignore-next deal.days_since_latest_status_change is checked above
  const isRed = (deal.days_since_latest_status_change ?? 0) > 9

  return (
    <AntTag icon={<IconPlanner $isRed={isRed} />} color={isRed ? 'red' : 'white'}>
      {deal.days_since_latest_status_change} {t('daysShort')}
    </AntTag>
  )
}
